import { useMutation, useQuery } from '@tanstack/react-query';
import inboundNumberReservationsService from '../services/inboundNumberReservationsService';

export const useGetSingleInboundNumberReservation = (
	inboundNumberReservationID: number,
	options?: { isEnabled?: boolean },
) => {
	return useQuery<InboundNumberReservation>({
		queryKey: ['inboundNumberReservation', inboundNumberReservationID],
		queryFn: () =>
			inboundNumberReservationsService.getSingleResource(
				inboundNumberReservationID,
			),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useGetAllInboundNumberReservations = (options?: {
	filters?: string;
	isEnabled?: boolean;
}) => {
	return useQuery<
		TavoittajaApiResponse<{
			inboundNumberReservations: InboundNumberReservation[];
		}>
	>({
		queryKey: ['inboundNumberReservations'],
		queryFn: () =>
			inboundNumberReservationsService.getAllResources({
				filters: options?.filters,
			}),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useDeleteInboundNumberReservation = () => {
	return useMutation({
		mutationKey: ['inboundNumberReservations'],
		mutationFn: (id: number) =>
			inboundNumberReservationsService.deleteSingleResource(id),
	});
};

export const useUpdateInboundNumberReservation = () => {
	return useMutation({
		mutationKey: ['inboundNumberReservationUpdate'],
		mutationFn: (data: Partial<UpdateInboundNumberReservationRequest>) =>
			inboundNumberReservationsService.update(data),
	});
};

export const useAddInboundNumberReservation = () => {
	return useMutation({
		mutationKey: ['inboundNumberReservation'],
		mutationFn: (data: AddInboundNumberReservationRequest) =>
			inboundNumberReservationsService.create(data),
	});
};
